import React from 'react';
import {TableCell, TableRow} from "@mui/material";
import {formatCurrency, formatDateISOSmall} from "../../utils/helpers";

const ProductRecapRow = ({
                             name, datetimeStart, datetimeEnd, quantity, unitPrice, tvaRate, options
                         }) => {

    return <React.Fragment>
        <TableRow>
            <TableCell>{name}<br/>{formatDateISOSmall(datetimeStart)} → {formatDateISOSmall(datetimeEnd)}
            </TableCell>
            <TableCell align="right">{quantity}</TableCell>
            <TableCell align="right">{formatCurrency(unitPrice)}</TableCell>
            <TableCell align="right">{tvaRate.toFixed(2)} %</TableCell>
            <TableCell align="right">{formatCurrency(quantity * unitPrice * (1 + tvaRate / 100))}</TableCell>
        </TableRow>

        {options.map((option, index) => (
            <TableRow key={index}>
                <TableCell sx={{pl: 4, background: 'whitesmoke'}}>{option.name}</TableCell>
                <TableCell sx={{background: 'whitesmoke'}} align="right">{option.quantity}</TableCell>
                <TableCell sx={{background: 'whitesmoke'}} align="right">{formatCurrency(option.price)}</TableCell>
                <TableCell sx={{background: 'whitesmoke'}} align="right">{option.tva.toFixed(2)} %</TableCell>
                <TableCell sx={{background: 'whitesmoke'}}
                           align="right">{formatCurrency(option.quantity * option.price * (1 + option.tva / 100))}</TableCell>
            </TableRow>
        ))}
    </React.Fragment>
}

export default ProductRecapRow;